import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { TeamGameMatch, TeamGameMatchTeam, UpdateStatus } from '../../../../database.schema';
import { useTournamentTeamGameMatchPlayResultScoreCardMutation } from '../../../api/tournament-data';
import { Button } from '../../common-styles/common-styles';

type UpdateButtonProps = {
  selectedTournamentIndex: number;
  matchIndex: number;
  teamIndex: number;
  recordedMatchTeams: Array<TeamGameMatchTeam>;
  teamGameMatch: TeamGameMatch;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
};

export const TeamGameMatchPlayUpdateButton: FC<UpdateButtonProps> = ({ selectedTournamentIndex, matchIndex, teamGameMatch, recordedMatchTeams, setUpdateStatus }) => {
  const navigate = useNavigate();
  const mutation = useTournamentTeamGameMatchPlayResultScoreCardMutation();
  const saveScorecard = () => {
    const dataToSave = { selectedTournamentIndex, matchIndex, recordedMatchTeams, teamGameMatch };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave },
        {
          onSuccess: (data) => {
            navigate(`/team-game-edit-results/${selectedTournamentIndex}/${matchIndex}`);
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
            console.log('<><><>ERROR<><><><', error);
          },
        },
      );
    }
    navigate(`/team-game-edit-results/${selectedTournamentIndex}/${matchIndex}`);
  };
  return (
    <Button data-testid="save-scorecard" onClick={() => saveScorecard()} disabled={!recordedMatchTeams}>
      Save
    </Button>
  );
};
